export const monitoringProfilesKeys = {
  all: () => {
    return ["profiles"] as const
  },

  noiseProfiles: (filters?: {
    name?: string
    limit?: number
    offset?: number
  }) => {
    if (filters) {
      return [
        ...monitoringProfilesKeys.all(),
        "noise",
        filters.name,
        filters.limit,
        filters.offset,
      ] as const
    }

    return [...monitoringProfilesKeys.all(), "noiseMonitoring"] as const
  },

  noiseProfile: (profileId: string) => {
    return [...monitoringProfilesKeys.noiseProfiles(), profileId] as const
  },

  motionAutomationProfiles: (
    orgId: string,
    filters?: { name?: string; limit?: number; offset?: number }
  ) => {
    const base = [
      ...monitoringProfilesKeys.all(),
      "motionAutomation",
      orgId,
    ] as const
    if (filters) {
      return [...base, filters.name, filters.limit, filters.offset] as const
    }
    return base
  },

  motionAutomationProfile: (orgId: string, profileId: string) => {
    return [
      ...monitoringProfilesKeys.motionAutomationProfiles(orgId),
      profileId,
    ] as const
  },

  smokeAndCoAlarmProfile: (orgId: string) => {
    return [...monitoringProfilesKeys.all(), "smokeAndCoAlarm", orgId] as const
  },

  fireAndCoAlarm: (orgId: string) => {
    return [...monitoringProfilesKeys.all(), "fireAndCoAlarm", orgId] as const
  },

  fireAndCoAlarmProfiles: (
    orgId: string,
    filters?: { name?: string; limit?: number; offset?: number }
  ) => {
    const base = [
      ...monitoringProfilesKeys.fireAndCoAlarm(orgId),
      "list",
    ] as const
    if (filters) {
      return [...base, filters.name, filters.limit, filters.offset] as const
    }
    return base
  },

  fireAndCoAlarmProfile: (orgId: string, profileId: string) => {
    return [
      ...monitoringProfilesKeys.fireAndCoAlarm(orgId),
      "detail",
      profileId,
    ] as const
  },

  fireAndCoSelfTestSchedule: (orgId: string, profileId: string) => {
    return [
      ...monitoringProfilesKeys.all(),
      "fireAndCoSelfTestSchedule",
      orgId,
      profileId,
    ] as const
  },

  icmProfiles: () => {
    return [...monitoringProfilesKeys.all(), "icm"] as const
  },

  icmProfile: (profileId: string) => {
    return [...monitoringProfilesKeys.all(), "icm", profileId] as const
  },

  guestAppProfiles: () => {
    return [...monitoringProfilesKeys.all(), "guestApp"] as const
  },

  tamperMessageProfiles: (orgId: string) => {
    return [...monitoringProfilesKeys.all(), "tamperMessage", orgId] as const
  },
}
